
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Draggable } from 'gsap/Draggable';
import { InertiaPlugin } from 'gsap/InertiaPlugin';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable, InertiaPlugin);

import { debounce as _debounce } from 'underscore';
// import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import '@benmajor/jquery-touch-events';
import 'jquery-clickout';

//import PinchZoom from 'pinch-zoom-js';

import slideshowCtrl        from './slideshowCtrl';
import widgetInfoMapLegend  from './widgetInfoMapLegend';


export default class{

    constructor( options ) {
        this.defaults = {
        	$el:                   false,
            draggable:             false,

            forceHeight:            true,
            mode:                   'click'
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'map_guide';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
        this.$win  = $(window);

        this.$desktop   = this.$el.find(  '.desktop-view' );
        this.$mobile   = this.$el.find(  '.mobile-view' );

        this.initDesktop( true );
        this.initMobile( true );

        
	}

	//---------------------------------------- DESKTOPS ---------------------------------------//
	initDesktop( b ){
		if ( b ){
            let $pin, $item;
            this.pins = [];
            this.items = [];
            this.$desktop.find( '.pin' ).each( ( i, el )=>{
                $pin = $(el);
                $pin.on( 'mouseenter', (e)=>{
                    this.onPinDesktopEvent( e, 'over' );
                });
                $pin.on( 'mouseleave', (e)=>{
                    this.onPinDesktopEvent( e, 'out' );
                });
                $pin.on( 'click', (e)=>{
                    this.onPinDesktopEvent( e, 'click' );
                });
                $pin.on( 'dblclick', (e)=>{
                    this.onPinDesktopEvent( e, 'dblclick' );
                });
                this.pins.push( $pin );
            });

            this.$desktop.find( '.point.type-info' ).on( 'mouseenter', (e)=>{
                this.onPinDesktopInfo( e, 'over' );
            });
            this.$desktop.find( '.point.type-info' ).on( 'mouseleave', (e)=>{
                this.onPinDesktopInfo( e, 'out' );
            });

            this.$desktop.find( '.item-grid' ).each( ( i, el )=>{
                $item = $(el);
                $item.on( 'mouseenter', (e)=>{
                    this.onItemDesktopEvent( e, 'over' );
                });
                $item.on( 'mouseleave', (e)=>{
                    this.onItemDesktopEvent( e, 'out' );
                });
                $item.attr( 'id', 'item-' + i );
                this.items.push( $item );
            });

            if ( !this.options.forceHeight ){
                this.$win.on( 'scroll', ()=>{this.updateDesktopOnScroll()} );
            }

            this.setDesktopSelection( document.location.href );
		}
		else{

            if ( !this.options.forceHeight ){
                this.$win.off( 'scroll', ()=>{this.updateDesktopOnScroll()} );
            }
		}
        this.debounceResize(b);
        this.initWidgets(b);

        if ( this.options.forceHeight ){
            if ( b ){
                this.onResize();
            }
            //setTimeout( ()=>this.setMapPin( true ), 200 )
        }
	}

    onPinDesktopInfo( e, action ){
        let $point = $(e.currentTarget), 
            $info = this.$desktop.find( '.rollover-info' ), 
            text = $point.attr( 'data-rollover' );
        
        if ( action === 'over' ){
            if ( text ){
                $info.text( text );
                $info.addClass( 'active' );
                $info.css({
                    left: $point.css( 'left' ),
                    top:  $point.css( 'top' )
                })
            }
        }
        else{
            if ( $info.hasClass( 'active' ) ){
                $info.removeClass( 'active' );
            }
        }
    }

    onPinDesktopEvent( e, action ){
        let $pin = $(e.currentTarget), 
            href =  $pin.attr( 'data-permalink' ), 
            $item;

        switch ( action ){ 
            case 'over':
                if ( this.options.mode === 'over' ){
                    this.clearAllSelections();
                    $item = this.getItemFromHref( href );
                    if ( $item.length > 0 ){
                        $item.find(  '> a' ).addClass( 'selected' );
                        this.scrollMarkersScrollTo( $item );
                    } 
                    $pin.parent().addClass('selected');
                }
            break;
            case 'out':
                if ( !this.$desktop.hasClass( 'scroll-trigger-mode' ) ){
                    this.clearItemsSelections();
                    $pin.parent().removeClass('selected');
                }
            break;
            case 'click':
                if ( this.options.mode === 'click' ){
                    this.clearAllSelections();
                    $item = this.getItemFromHref( href );
                    if ( $item.length > 0 ){
                        $item.find(  '> a' ).addClass( 'selected' );
                        this.scrollMarkersScrollTo( $item );
                    } 
                    $pin.parent().addClass('selected');
                    $pin.addClass('selected');
                }   
            break;

            case 'dblclick':
                this.main.barba_triggerURL( href, $pin );
            break;
        }
    }
    clearItemsSelections(){
        let i  = this.items.length, $item;
        while( i-- ){
            $item = this.items[ i ];
            $item.find(  '> a'  ).removeClass( 'selected' );
        }
    }
    getItemFromHref( href ){
        let i  = this.items.length, $item, r = [];
        while( i-- ){
            $item = this.items[ i ];
            //console.log( $item.find(  '> a'  ).attr( 'href' ) );
            if ( $item.find(  '> a'  ).attr( 'href' ) === href ){
                r = $item;
            }
        }
        return r;
    }
    onItemDesktopEvent( e, action ){
        let $item = $(e.currentTarget),
            href = $item.find( '> a' ).attr( 'href' ),
            $pin;

        switch ( action ){ 
            case 'over':
                this.clearAllSelections();
                $pin = this.getPinFromHref( href );
                if ( $pin.length > 0 ){
                    $pin.addClass( 'selected' );
                    $pin.parent().addClass('selected');
                } 
            break;
            case 'out':
                this.clearPinsSelections();
            break;
        }
    }
    clearPinsSelections(){
        let i  = this.pins.length, $pin;
        while( i-- ){
            $pin = this.pins[ i ];
            $pin.removeClass( 'selected' );
            $pin.parent().removeClass('selected');
        }
    }
    getPinFromHref( href ){
        let i  = this.pins.length, $pin, r = [];
        while( i-- ){
            $pin = this.pins[ i ];
            if ( $pin.attr( 'data-permalink' ) === href ){
                r = $pin;
            }
        }
        return r;
    }
    clearAllSelections(){
        this.clearPinsSelections();
        this.clearItemsSelections();               
    }

    //---------------- call only once if map is loaded into specific location marker guide -----------------------------//
    setDesktopSelection( href ){
        let  $pin = this.getPinFromHref( href ), $item = this.getItemFromHref( href );
        if ( $pin.length > 0 ){
            $pin.addClass( 'selected' );
            $pin.parent().addClass('selected');
        } 
        if ( $item.length > 0 ){
            $item.find(  '> a' ).addClass( 'selected' );

            if ( !this.$desktop.hasClass( 'scroll-trigger-mode' ) ){
                this.scrollMarkersScrollTo( $item )
            }
        } 
     }
     scrollMarkersScrollTo( $item ){
        let id = $item.attr( 'id' );

        if ( this.$desktop.hasClass( 'scroll-trigger-mode' ) ){
            gsap.to(  this.$win, {duration: 0.8, scrollTo:{ y: '#' + id , offsetY: 40 } });
        }
        else{
            gsap.to(  this.$desktop.find( '.markers-scroll' ), {duration: 0.4, scrollTo:{ y: '#' + id , offsetY: 40 } });
        }
     }

    
    // ---------------------- ON RESIZE -----------------//
    updateDesktopLayout(){
        let $v = this.$desktop.find( '.virtual-image-map' ),
        $footer = $('#footer'),
        $markers = this.$desktop.find( '.markers-scroll' ),
        h = this.$win.height(),
        scrollTop = this.$win.scrollTop(),
        top = $v.offset().top,
        margin, 
        $m,
        $tiles;

        $m = $v.find( '.tile.main-tile' );

        if ( this.options.forceHeight ){

            // show the top tile
            $v.find( '.tile-top' ).show(0);

             this.setMapPin( false );

            // force the map to the browser height, unless its natural height is above the window height
            if ( $m.height() > h ){
                $v.height( $m.height() );
            }
            else{
                $v.height( h );
            }

            // center tiles respect available height of the map
            $tiles = $v.find( '.tiles' );
            gsap.set( $tiles, {y: Math.floor( $v.height()/2-$tiles.height()/2 ) });

            // set the natural height of the markers scroll
            this.$desktop.addClass( 'scroll-trigger-mode' );
            $markers.css({
                'height': Math.ceil( $markers.find( '.grid-wrapper' ).outerHeight() )
            });
            
            this.setMapPin( true );

        }
        else{
            $v.height( $m.height() );
            
            // move map up when the map is not fully visible on the window
            //console.log( h + ', map height = ' + this.$el.height() + ', top = ' + this.$el.offset().top );
            if ( h - this.$el.offset().top < this.$el.height()  ){

                margin = this.calcMarginTop( $m.height() );
                $v.height( $m.height() - margin );
                //$m.css({top: '-' + margin + 'px' });
                gsap.to( $m, {y:- margin, duration:0.3, ease:'power.easeOut'});
            }
            else{
                //$m.css({top: '0px' });
                gsap.to( $m, {y:0, duration:0.3, ease:'power.easeOut'});
            }


            // if the map goes below the window 
            if ( $v.height() + top >= h ){
                
                this.$desktop.addClass( 'scroll-trigger-mode' );
                $markers.css({
                    'height': 'auto',
                    'margin-top': 0
                });
                gsap.set(  $markers, { scrollTo: 0 });
                this.setMapPin( true )
            }
            else{

                this.$desktop.removeClass( 'scroll-trigger-mode' );
                this.setMapPin( false )
            }
        }

        this.updateDesktopOnScroll()

    }

    updateDesktopOnScroll(){
        let $v = this.$desktop.find( '.virtual-image-map' ),
        $footer = $('#footer'),
        $markers = this.$desktop.find( '.markers-scroll' ),
        h = this.$win.height(),
        scrollTop = this.$win.scrollTop(),
        top = $v.offset().top;

        if ( this.$desktop.hasClass( 'scroll-trigger-mode' ) ){

        }
        else{

            // show/hide footer
            if ( $v.height() + top > h ){
                //console.log( 'hide footer' )
                //$footer.hide(0);

                if ( scrollTop < top ){
                    $markers.height( h - top + scrollTop );
                    $markers.css({
                        'margin-top' : 0
                    })
                }
                else{
                    $markers.height( h );
                    $markers.css({
                        'margin-top' : scrollTop - top
                    })
                }
                
            }
            else{
                //console.log( 'show footer' )
                //$footer.show(0);
                
                $markers.height( $v.height() );
                $markers.css({
                    'margin-top' : 0
                })
            }        


        }
    }

    setMapPin( b ){
        if ( b ){
            let $map = this.$desktop.find( '.virtual-image-map' ),
                $markers = this.$desktop.find( '.markers-scroll' );

            this.setMapPin( false );

            ScrollTrigger.create({
                trigger: $map,
                start: "bottom bottom",
                pin: true,
                pinSpacing: false,
                end: ()=>{ return $markers.height() - $map.height() + ( $map.height() - this.$win.height() + $map.offset().top ) },
                //toggleClass: "activate-nav-compact",
                scrub: true,
                markers: false,
                id: this.getMapPinId()
            })

        }
        else{

            if ( ScrollTrigger.getById( this.getMapPinId() ) ){
                ScrollTrigger.getById( this.getMapPinId() ).kill();
            }
        }
    }

    getMapPinId(){
        return  this.namespace + '-map-pin';
    }


    //---------------------------------------- MOBILE ---------------------------------------//
    initMobile( b ){

        if ( b ){

            this.onResize();

            this.$mobile.find( '.drawer-button').on( 'tap', ()=>{
                this.toggleMobileDrawer( true );
            });

            this.$mobile.find( '#map-drawer-mobile' ).on( 'clickout', ()=>{
                // this.openMobileDrawer( false );
            });

            this.$mobile.find( '.virtual-image-map' ).on( 'tap', (e)=> {this.onTabMobileMap(e)} );
        }
        else{

            this.$mobile.find( '.drawer-button').off( 'tap', ()=>{
                this.toggleMobileDrawer( true );
            });

            this.$mobile.find( '#map-drawer-mobile' ).off( 'clickout', ()=>{
                // this.openMobileDrawer( false );
            });

            this.$mobile.find( '.virtual-image-map' ).off( 'tap', (e)=> {this.onTabMobileMap(e)} );

        }
        this.initSliderMarkers( b );
        this.initMobileInteractivity( b );
        this.initMobileMap( b );
    }

    toggleMobileDrawer(){
        if( !this.$mobile.hasClass( 'drawer-open') ){
            this.openMobileDrawer( true );
            this.showSlider( false );
        }
        else if( this.$mobile.hasClass( 'drawer-open') ){
            this.openMobileDrawer( false );
        }
    }

    openMobileDrawer(b){
        if( b ){
            this.$mobile.addClass( 'drawer-open');
        }
        else {
            this.$mobile.removeClass( 'drawer-open');
        }
    }

    onTabMobileMap(e){
        this.openMobileDrawer( false );
        if ( $(e.target).hasClass(  'overlay-map' ) ){
            this.showSlider( false );
            this.clearAllMobileSelections();
        } 
    }

    initSliderMarkers(b){
        let $s =  this.$mobile.find( '.slider-markers-map' ), args;
        if ( b ){


            $s.find( '.slick-slider' ).on( 'beforeChange', (event, slick, currentSlide, nextSlide) =>{
                this.clearAllMobileSelections();
            });
            $s.find( '.slick-slider' ).on( 'afterChange', (event, slick, currentSlide ) =>{
                this.setPinSelectionFromIndex( currentSlide );
            });

            args = {
                dots: false,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                centerMode: true,
                variableWidth: true,
                arrows: false,
                autoplay: false
            }
            // important: Remember to pass the dom element!!!
            this.slider = new slideshowCtrl( {
                $el : $s,
                customArgs: true,
                args: args
            });

        }
        else{
            this.slider.destroy();
        }       
    }

    initMobileInteractivity( b ){
        if ( b ){
            let $pin, $item;
            this.m_pins = [];
            this.m_items = [];
            this.$mobile.find( '.pin' ).each( ( i, el )=>{
                $pin = $(el);
                $pin.on( 'tap', (e)=>{
                    this.onPinMobileEvent( e, 'tap' );
                });
                $pin.on( 'doubletap', (e)=>{
                    this.onPinMobileEvent( e, 'doubletap' );
                });
                this.m_pins.push( $pin );
            });
            this.$mobile.find( '.point.type-info' ).each( ( i, el )=>{
                $pin = $(el);
                $pin.on( 'tap', (e)=>{
                    this.onPinMobileInfo( e, 'tap' );
                });
            });
            this.$mobile.find( '#map-drawer-mobile .item-grid' ).each( ( i, el )=>{
                $item = $(el);
                $item.attr( 'id', 'item-mobile-' + i );
                this.m_items.push( $item );
            });
            this.setMobileSelection( document.location.href );
        }
        else{
        }
    }

    onPinMobileInfo( e, action ){
        let $info = this.$mobile.find( '.rollover-info' );

        if ( action === 'tap' ){

            let $point = $(e.currentTarget), text = $point.attr( 'data-rollover' );

            if ( $info.hasClass( 'active' ) ){
                $info.removeClass( 'active' );
            }
            else{ 
                if ( text ){
                    $info.text( text );
                    $info.addClass( 'active' );
                    $info.css({
                        left: $point.css( 'left' ),
                        top:  $point.css( 'top' )
                    })
                }
            }
        }
        else{
            // action close
            if ( $info.hasClass( 'active' ) ){
                $info.removeClass( 'active' );
            }
        }
    }


    getItemMobileFromHref( href ){
        let i  = this.m_items.length, $item, r = [];
        while( i-- ){
            $item = this.m_items[ i ];
            if ( $item.find(  '> a'  ).attr( 'href' ) === href ){
                r = $item;
            }
        }
        return r;
    }
    clearMobilePinsSelections(){
        let i  = this.m_pins.length, $pin;
        while( i-- ){
            $pin = this.m_pins[ i ];
            $pin.removeClass( 'selected' );
            $pin.parent().removeClass('selected');
        }
    }
    getPinMobileFromHref( href ){
        let i  = this.m_pins.length, $pin, r = [];
        while( i-- ){
            $pin = this.m_pins[ i ];
            if ( $pin.attr( 'data-permalink' ) === href ){
                r = $pin;
            }
        }
        return r;
    }
    clearAllMobileSelections(){
        this.clearMobilePinsSelections();
        this.clearMobileItemsSelections();
        this.onPinMobileInfo({},'close');             
    }
    onPinMobileEvent( e, action ){
        let $pin = $(e.currentTarget),
            $item;

        switch ( action ){ 
            case 'tap':
                this.setSliderIndex( parseInt( $pin.attr( 'data-index' ) ) );
                this.centerMobileMap( $pin );
            break;
            case 'doubletap':
                this.main.barba_triggerURL( $pin.attr( 'data-permalink' ), $pin );
            break;
        }
    }
    setPinSelectionFromIndex( index ){
        let i  = this.m_pins.length, $pin, $item;
        while( i-- ){
            $pin = this.m_pins[ i ];
            if ( parseInt( $pin.attr( 'data-index' ) ) === index ){
                $pin.addClass( 'selected' );
                $pin.parent().addClass('selected');
                this.centerMobileMap( $pin );
                $item = this.getItemMobileFromHref( $pin.attr( 'data-permalink' ) );
                if ( $item.length > 0 ){
                    this.scrollMobileMarkersScrollTo( $item );
                }
            }
        }        
    }
    scrollMobileMarkersScrollTo( $item ){
        let id = $item.attr( 'id' );
        gsap.to(  this.$mobile.find( '#map-drawer-mobile .scroll-drawer' ), {duration: 0.4, scrollTo:{ y: '#' + id , offsetY: 80}});
    }
    clearMobileItemsSelections(){
        gsap.to(  this.$mobile.find( '#map-drawer-mobile .scroll-drawer' ), {duration: 0, scrollTo: 0} );
    }
    setSliderIndex( i ){
        let $slick = this.slider.getSlider();
        $slick.slick( 'slickGoTo', i );
        this.showSlider( true );
    }
    showSlider( b ){
        if ( b ){
            this.$mobile.addClass( 'show-slider' );
        }
        else{
            this.$mobile.removeClass( 'show-slider' );
            this.resetPositionMobileMap();
        }
    }

    //---------------- call only once if map is loaded into specific location marker guide -----------------------------//
    setMobileSelection( href ){
        let  $pin = this.getPinMobileFromHref( href );
        if ( $pin.length > 0 ){
            $pin.trigger( 'tap' );
        } 
    }

    initMobileMap(b){
        let $t = this.$mobile.find( '.tiles' );

        if (b){

            /*
            this.onResize();       
            
            this.PinchZoom = new PinchZoom( $t[0], {
                draggableUnzoomed: false,
                minZoom: 1,
                onZoomStart: function(object, event){
                    // Do something on zoom start
                    // You can use any Pinchzoom method by calling object.method()
                },
                onZoomEnd: function(object, event){
                    // Do something on zoom end
                }
            });
            */
            if ( this.options.draggable ){
                this.draggableMap = Draggable.create( this.$mobile.find( '.tiles' ) , {
                    allowEventDefault: true,
                    bounds: this.$mobile.find( '.virtual-image-map' ),
                    inertia: true     
                });
            }
        }
        else{
            //this.draggableMap.kill()
        }     
    }

    centerMobileMap( $pin ){
        // map container
        let $v = this.$mobile.find( '.virtual-image-map' ), 
            // map tile inner to move
            $t = this.$mobile.find( '.tiles' ), 
            // slider to calculate the offset of visible map
            $s = this.$mobile.find( '.slider-markers-map' ), 
            y, dy;

        // position point respect top of the map to move the map as the pin reach the top
        y =  $v.offset().top  - $pin.parent().offset().top + gsap.getProperty( $t[0], 'y');

        // rest the "visiable area"/2 to center
        dy = $s.offset().top - $v.offset().top;

        y += dy/2;

        // don't exceed the container bounds
        y = Math.min( Math.max( $v.height() - $t.height(), y ), 0 );

        gsap.to( $t, {y:Math.max( $v.height() - $t.height(), y ), duration: 0.4, onUpdate:  ()=>this.draggableUpdate() } );

    }

    resetPositionMobileMap(){
        let  $t = this.$mobile.find( '.tiles' );
        gsap.to( $t, {y:0, duration: 0.4, onUpdate:  ()=>this.draggableUpdate() } );
    }

    updateMobileLayout(){
        let $v = this.$mobile.find( '.virtual-image-map' ), 
        $m = this.$mobile.find( '.tile.main-tile' ), 
        h = this.$win.height(),
        y = this.$mobile.offset().top;

        if ( $m.height() >= h - y ){
            $v.height( $m.height() );
        }
        else{
            $v.height( h - y );
        }
        

        
        this.draggableUpdate();
    }



    //---------------------------------------- COMMONS -----------------------------------------//
    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){

        //--------------------- mobile --------------------//
        this.updateMobileLayout();

        //--------------------- desktop ------------------//
        this.updateDesktopLayout();
    }

    calcMarginTop( map_h ){
        let or_map_h = 1744, 
            or_margin = 110, // above26th
            or_margin_max = 170; // below 26th when green map start

            // or_map_h : or_margin = map_h : x

        return (map_h*or_margin)/or_map_h;
    }

    draggableUpdate(){
        
        if ( this.draggableMap ){
            //this.draggableMap.update( true );
        } 
           
    }

    setDraggableMap(){

    }

    initWidgets(b){
        if ( b ){
            let $el = this.$el.find( '.widget-info-map-legend' );
            this.$infoLegend = new widgetInfoMapLegend({
                $el: $el
            });
            $el.on( 'info-map-legend:open', ()=>{
                this.showSlider( false );
            } )
        }
        else{
            this.$infoLegend.destroy();
            this.$infoLegend = null;
        }
        
    }


    //---------------------------------------- METHODS ---------------------------------------//

    scrollPageTo( $a ){
        gsap.to(this.$win, {duration: 0, scrollTo: $a.offset().top - this.$win.height()/2 + $a.find( 'img' ).height()/2 });
    }

    destroy(){
		if ( this.$el.length > 0){
            this.initDesktop( false );
    		this.initMobile( false );
    	}
    }

}


